import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import * as jwt_decode from 'jwt-decode';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { debug } from 'util';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export const TOKEN_NAME = 'jwt_token';

@Injectable()
export class AuthService {

  private url = environment.authApiUrl;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private loggedIn = new BehaviorSubject<boolean>(false);
  private loggedAdmin = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  get isAdmin() {
    return this.loggedAdmin.asObservable();
  }

  constructor(private http: Http,
              private router: Router) { }

  getToken(): string {
    return localStorage.getItem( TOKEN_NAME );
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_NAME, token);
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) {token = this.getToken(); }
    if (!token) {return true; }

    const date = this.getTokenExpirationDate(token);
    if (date === undefined ) {return false; }
    return !(date.valueOf() > new Date().valueOf());
  }

  reset(user): Observable<any[]> {
    return this.http
        .post(`${this.url}/recovery`, JSON.stringify(user), { headers: this.headers })
        .map(response => {
            return <any[]>response.json();
        });
  }

  register(details): Observable<any> {

    return this.http
      .post(`${this.url}/signup`, JSON.stringify(details), { headers: this.headers });
  }


  prefillUserGoal(details): Observable<any> {

    // do this once off here
    const token = localStorage.getItem(TOKEN_NAME);
    this.headers.set('Authorization', `Bearer ${token}`);
    return this.http
      .post(`${this.url}/prefill`, JSON.stringify(details), { headers: this.headers });
  }


  login(user): Observable<any> {
    return this.http
        .post(`${this.url}/login`, JSON.stringify(user), { headers: this.headers })
        .map(response => {
            return response;
        });
  }


  resetPassword(details): Subscription {

    return this.http
      .post(`${this.url}/reset`, JSON.stringify(details), { headers: this.headers })
      .subscribe(
      res => {
        this.router.navigate(['/login']);
      });
  }


  logout() {
    this.loggedIn.next(false);
    this.loggedAdmin.next(false);
    this.router.navigate(['/login']);
  }


  private handleError(error: Response) {
      return Observable.throw(error.statusText);
  }

  setTokenAndForward(res, doNotForward = false): void {
    if (res.json().token) {
      this.setToken(res.json().token);
      // set logged in as true
      this.loggedIn.next(true);
      this.isUserAdmin(res);

      if (!doNotForward) {
        this.router.navigate(['/networth']);
      }
    }
  }


  private isUserAdmin(res) {
    // check the user role
    if (jwt_decode(res.json().token).role === 'admin') {
      this.loggedAdmin.next(true);
    }
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/auth.service.ts